import React, {Component} from 'react';
import {Button} from "antd";
import {getLeasingIdealDays} from "../../appRedux/actions";
import {connect} from "react-redux";
import './style.css';

class IdealDays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      days: {},
      load: {},
      cachedIdealDays:null,
    }
  }

  componentDidMount() {
    if (this.props.id) {
      const allIdealDays = this.props.allIdealDays;
      if (!allIdealDays[this.props.id])
        this.props.getLeasingIdealDays(this.props.id);
      else {
        this.setState({
          cachedIdealDays: allIdealDays[this.props.id]
        })
      }

    }

  }

  //
  componentDidUpdate(prevProps, prevState) {
    if(!this.state.cachedIdealDays && prevProps.days !== this.props.days) {
      let dys = this.state.days;
      let ld = this.state.load;
      if(this.props.days !== null && this.props.days.days !== null) {
        dys[this.props.days.id] = this.props.days.days;
        ld[this.props.days.id] = this.props.days.loading;
        this.setState({
          days: dys,
          load: ld,
        })

        this.props.addIdealDaysToRecord(this.props.id, {
          days: dys,
          load: ld,
        })
      }
    }
  }

  onClick = (asset) => {
    if(asset) {
      // const win = window.open(`asset/history-report/${this.props.id}`, "_blank");
      // win.focus();
    }
  }

  render() {
    const {days, load} = this.state;
    return (
      <div>
        {
          this.state.cachedIdealDays ?
              <Button style={{width:'50px'}} shape={'round'} size='small' loading={false}
                      onClick={() => this.onClick(this.props.id)}>
                {this.state.cachedIdealDays.days[this.props.id]}
              </Button>
              :
          <Button style={{width:'50px'}} shape={'round'} size='small' loading={typeof days[this.props.id] === 'number' ? false : true}
                  onClick={() => this.onClick(this.props.id)}>
            {days[this.props.id]}
          </Button>
        }
      </div>
    );
  }
}


const mapStateToProps = ({auth, leasing}) => {
  return {
    authUser: auth.authUser,
    days: leasing.idealDays,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getLeasingIdealDays
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(IdealDays);
